import React from "react";
import "babel-polyfill";
import { HashRouter, Route, Switch } from "react-router-dom";
import Home from "components/home/Home";
import Workspace from "components/Workspace";
import ScrollToTop from "components/ui/ScrollToTop";
import MobileNavbar from "components/headers/MobileNavbar";
import DesktopNavbar from "components/headers/DesktopNavbar";
import Footer from "components/footers/Footer";
import Hydrate from "components/Hydrate";
import NotificationContainer from "components/notification-container/NotificationContainer";
import EmailModal from "components/email/EmailModal";
import CATEGORIES from "utils/categories";
import { isPopulated } from "utils/helpers";
import MessageBanner from "components/ui/MessageBanner";
import "antd/dist/antd.min.css";
import "styles/App.scss";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
    };
    // TODO: re-activate this
    window.onbeforeunload = () => {
      return this.handleCloseTab();
    };
  }

  handleCloseTab = () => {
    const populated = CATEGORIES.map((cat) => isPopulated(cat));
    if (populated.some((cat) => cat === true)) {
      this.showModal();
      return false;
    } else {
      return true;
    }
  };

  showModal = () => this.setState({ modalVisible: true });
  closeModal = () => this.setState({ modalVisible: false });

  render() {
    return (
      <HashRouter>
        <ScrollToTop />
        <Hydrate />
        <EmailModal
          modalVisible={this.state.modalVisible}
          closeModal={this.closeModal}
        />
        <MessageBanner
          message={
            "The ATAR eligibility rules used in Subject Compass only apply to students in Year 10 in 2023 and beyond."
          }
        />
        <MobileNavbar />
        <DesktopNavbar />
        <NotificationContainer />
        <Switch>
          <Route exact={true} path="/" component={Home} />
          <Route path="*" component={Workspace} />
        </Switch>
        <Footer />
      </HashRouter>
    );
  }
}

export default App;
